export default {
  title: 'Pedidos de eliminação de dados',
  fields: {
    created_at: 'Solicitado em',
    restaurant: 'Restaurante',
    customer: 'Cliente',
    note: 'Nota',
    status: 'Estado',
    completed_by: 'Concluído por',
    actions: 'Ações',
  },
  statuses: {
    pending: 'Pendente',
    completed: 'Concluído',
  },
  buttons: {
    approve: 'Aprovar',
  },
  modals: {
    approve: {
      title: 'Aprovar eliminação de dados de {{name}}?',
      description:
        'Esta ação elimina permanentemente os dados pessoais do cliente e não pode ser desfeita. O pedido será marcado como concluído.',
    },
  },
  toasts: {
    failed_to_load_data: 'Erro ao carregar dados',
    failed_to_approve: 'Erro ao aprovar pedido',
    approved: 'Pedido aprovado e dados eliminados',
  },
};
